/**
 * v-hasPermission 是否有操作权限，针对于按钮
 */

export const permit={
    'ADMIN':['project_del','project_export','project_changer_user','project_raw_release','project_edit','project_detail','projects_share','project_modifyExpTime','project_customer_edit','project_edit_project','project_add'],
    'MANAGER':['project_del','project_export','project_changer_user','project_raw_release','project_edit','project_detail','projects_share','project_modifyExpTime','project_add'],
    'SALES':['project_share','projects_share','project_add'],
    'SALES_ADMIN':['project_share','projects_share','project_add'],
    'AUDIT':['project_raw_release','project_detail','project_changer_user'],
    'ANALYST':['project_detail','project_edit','project_add'],
    'USER':['project_share','projects_share','project_customer_edit','project_add'],
    'TECH':['project_detail','projects_share','project_edit_project','project_add'],
}
import store from '@/store'
export default {
    inserted(el, binding, vnode) {
        const role = store.getters && store.getters["right/getRole"]
        const { value } = binding
        if(role&&!permit[role].includes(value)){
            el.parentNode && el.parentNode.removeChild(el)
        }
    }
}
